<tr>
    @for(meta of metadata?.columns; track meta; let index=$index)
    {
        <th [ngClass]="options.cssClasses.thDefault | mergeCssClasses: [meta?.headerClass]" 
            [style.width]="meta?.width"
            [title]="meta?.headerTooltip || meta?.title"
            [orderable]="!!meta?.ordering"
            [orderById]="meta?.id">

            @if(meta?.titleVisible)
            {
                @if(meta?.headerTemplate)
                {
                    <ng-container *ngTemplateOutlet="meta?.headerTemplate ?? null; context: meta | cellContext: index" />
                }
                @else 
                {
                    <span [ngClass]="options.cssClasses.spanContent">{{meta?.title}}</span>
                }
            }
        </th>
    }
</tr>